module.exports = __webpack_public_path__ + "static/media/cctv4.1349f497.mp4";